export const getQueryStringFromParams = (
    queryParams: Record<string, string | number | boolean | unknown>,
) => {
    return new URLSearchParams(
        Object.entries(queryParams).map(([key, value]) => [key, String(value)]),
    ).toString();
};
